<template>
  <div class="experience-shell">
    <div class="experience-scroll">

      <div class="timeline mt-4">
        <article
          v-for="(item, index) in experience"
          :key="index"
          class="experience-card"
        >
          <div class="card-accent"></div>
          <div class="card-meta">
            <span class="experience-year">{{ item.year }}</span>
            <span class="experience-role">{{ item.role }}</span>
          </div>
          <div class="card-body">
            <h3 class="experience-company">{{ item.company }}</h3>
            <ul class="experience-points">
              <li v-for="(point, i) in item.points" :key="i">{{ point }}</li>
            </ul>
            <div class="experience-tags" v-if="item.tags?.length">
              <span v-for="(tag, t) in item.tags" :key="t" class="tag">{{ tag }}</span>
            </div>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      experience: [
        {
          year: '2022 – Present',
          role: 'IT Technician & Web Developer',
          company: 'Ministry of Social Development (Santiago del Estero)',
          points: [
            'Lead technical support for 10 departments and 300+ users, covering hardware, software, network, and access issues.',
            'Maintain CAT6 cabling, IP configuration, and network equipment across 5 institutional servers.',
            'Build and maintain internal apps with Vue.js, Express.js, and MySQL (inventory, employee notifications, social-card management).',
            'Administer SQL Server and MySQL databases: maintenance, validation, and operational support.',
            'Replace paper-based workflows with web apps used daily across multiple departments.',
          ],
          tags: ['Vue.js', 'Express.js', 'MySQL', 'SQL Server', 'Nginx', 'Linux', 'Networking'],
        },
        {
          year: '2019 – 2020',
          role: 'Database Administrator',
          company: 'Editorial AMERICANIA',
          points: [
            'Managed and updated book and magazine databases in Excel for editorial operations.',
            'Organized the bibliographic catalog to improve searchability and internal access to publication records.',
          ],
          tags: ['Excel', 'Data Management', 'Cataloging'],
        },
      ],
    };
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap');

.experience-shell {
  width: 100%;
  height: calc(100svh - 60px);
  max-height: calc(100svh - 60px);
  margin: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;
}
.mt-4{
  margin-top: 1rem;
}
.experience-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 28px 12svw;
  box-sizing: border-box;
}

.experience-header {
  margin-bottom: 18px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  background: linear-gradient(
    to right,
    rgba(255, 94, 0, 0.12),
    transparent 55%
  );
}

.section-title {
  margin: 0;
  font-family: 'Bebas Neue', sans-serif;
  font-size: 2rem;
  letter-spacing: 2px;
  font-weight: 400;
  color: #fff;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.section-subtitle {
  margin: 6px 0 0;
  font-size: 0.9rem;
  color: rgba(220, 220, 225, 0.75);
}

.timeline {
  display: flex;
  flex-direction: column;
  gap: 14px;
  position: relative;
}

.timeline::before {
  content: '';
  position: absolute;
  left: 6px;
  top: 8px;
  bottom: 8px;
  width: 2px;
  background: linear-gradient(
    to bottom,
    rgba(255, 94, 0, 0.75),
    rgba(255, 196, 0, 0.2),
    transparent
  );
}

.experience-card {
  position: relative;
  display: grid;
  grid-template-columns: 170px 1fr;
  gap: 16px;
  margin-left: 18px;
  padding: 14px 16px;
  background: linear-gradient(
    120deg,
    rgba(40, 40, 44, 0.92),
    rgba(22, 22, 24, 0.88)
  );
  clip-path: polygon(0 0, 100% 0, 100% calc(100% - 12px), calc(100% - 12px) 100%, 0 100%);
  box-shadow:
    0 10px 24px rgba(0, 0, 0, 0.35),
    inset 0 1px 0 rgba(255, 255, 255, 0.06);
  box-sizing: border-box;
}

.card-accent {
  position: absolute;
  left: -18px;
  top: 18px;
  width: 12px;
  height: 12px;
  background: #ff7a2a;
  box-shadow: 0 0 10px rgba(255, 120, 0, 0.55);
  clip-path: polygon(50% 0, 100% 50%, 50% 100%, 0 50%);
}

.card-meta {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.experience-year {
  font-family: 'Bebas Neue', sans-serif;
  font-size: 1.15rem;
  letter-spacing: 1px;
  color: #ffb347;
  text-shadow: 0 0 10px rgba(255, 120, 0, 0.25);
}

.experience-role {
  font-size: 0.82rem;
  line-height: 1.3;
  color: rgba(180, 220, 255, 0.9);
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.card-body {
  min-width: 0;
}

.experience-company {
  margin: 0 0 8px;
  font-size: 1.05rem;
  font-weight: 700;
  color: #fff;
}

.experience-points {
  margin: 0;
  padding-left: 16px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.experience-points li {
  font-size: 0.9rem;
  line-height: 1.4;
  color: rgba(230, 230, 235, 0.9);
}

.experience-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 12px;
}

.tag {
  padding: 3px 8px;
  font-size: 0.72rem;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: #e8ddd0;
  background: rgba(255, 94, 0, 0.12);
  border: 1px solid rgba(255, 140, 60, 0.35);
  clip-path: polygon(6% 0, 100% 0, 94% 100%, 0 100%);
}

@media (max-width: 1175px) {
  .experience-scroll {
    padding: 22px 5svw;
  }
}

@media (max-width: 850px) {
  .experience-scroll {
    padding: 14px 16px;
  }
  .timeline::before {
    left: 4px;
  }
  .experience-card {
    grid-template-columns: 1fr;
    gap: 8px;
    margin-left: 16px;
    padding: 12px;
  }
  .card-accent {
    left: -16px;
    top: 16px;
  }
  .section-title {
    font-size: 1.65rem;
  }
}

@media (max-width: 550px) {
  .experience-scroll {
    padding: 12px;
  }
  .experience-points li {
    font-size: 0.84rem;
  }
  .experience-company {
    font-size: 0.98rem;
  }
  .tag {
    font-size: 0.66rem;
  }
}
</style>
